import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Car, ArrowRight } from 'lucide-react';

// Routes where a persistent "Book" CTA is redundant or intrusive.
const HIDDEN_PREFIXES = ['/book', '/admin', '/inspection', '/report', '/payment', '/firstlook/start', '/login'];

const StickyBookButton = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [pathname]);

  const hidden = HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + '/'));
  if (hidden) return null;

  return (
    <button
      onClick={() => navigate('/book')}
      aria-label="Book an inspection"
      data-testid="sticky-book-btn"
      className={`fixed bottom-5 right-5 z-[70] inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold pl-5 pr-6 py-3.5 shadow-xl shadow-orange-500/40 transition-all duration-300 hover:scale-[1.03] ${
        visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <Car className="w-5 h-5" />
      <span>Book Inspection</span>
      <ArrowRight className="w-4 h-4" />
    </button>
  );
};

export default StickyBookButton;
